module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAABOklEQVQ4ja2UL0tDYRSHnzuxCYKIQYYgIoZ9CEHQtmIxWAyCwbhs02Y0ThYUDAuiQYM2kx/AYhqICIJTHIhpj2HnymXsr/PAyz33/b2/555zLveiVv3fqCbqDPAATDN61IFCogJsAqchHADnf4S+AbUUCnAJFIFXoACUgNUhgNfAHgBqumbVeszlTJ1TGwPO8UPNp6xspQBbQCXydVozWupS2QqwEfk2cPyrZCpN11U8/UWd6qCjTqrPce5GTbJ6J0Ne/QzDSRdoOfSGOt+udzKg7mTmVWzT1tRmaLud/N2giXobxqdoF3VCrcX+nZobBkq0lb79cuwdxf2XutjN2wtKtKd6oS5n2i718vWDJgFcUB8DeK+OjQIl5nYYwG+10M+TG+DzawLvke/T+vn0jgEqRR1XK3Hte/4HTO0YSryXxaAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/metier.png
// module id = U/am
// module chunks = 0